import { styled, Typography } from '@mui/material'
import React from 'react'
import SalesAgreementListItem from './SalesAgreementListItem'
import { SalesAgreement } from './storage'
import { TestIds } from '../../testIds'
import NoSalesAgreement from './NoSalesAgreement'
import { CONTACT_CARD_TITLE } from '../../util/consts'

export const AgreementsListConatiner = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  listStyle: 'none',
  paddingLeft: 0,
})

interface ActiveAgreementsProps {
  activeAgreements: SalesAgreement[] | undefined
  upcomingAgreements: SalesAgreement[] | undefined
}

const ActiveAgreementsTabPanel = ({
  activeAgreements,
  upcomingAgreements,
}: ActiveAgreementsProps) => {
  const isNoAgreement = React.useMemo(() => {
    return activeAgreements?.length === 0 && upcomingAgreements?.length === 0
  }, [activeAgreements, upcomingAgreements])

  const renderBody = React.useMemo(() => {
    if (isNoAgreement) {
      return (
        <NoSalesAgreement
          body={'You do not have any active Sales Agreements.'}
          contactTitle={CONTACT_CARD_TITLE.underTabs}
        />
      )
    } else {
      return (
        <>
          <AgreementsListConatiner
            data-testid={TestIds.feat.agreement.tabView.activeAgreementsList}
          >
            {activeAgreements?.map((e) => (
              <SalesAgreementListItem
                key={e.id}
                {...e}
                products={e.lines.map((p) => p.productDescription)}
                percentageFulfilled={e.percentageFulfilled}
              />
            ))}
          </AgreementsListConatiner>
          {!!upcomingAgreements?.length && (
            <>
              <Typography variant='h4' component='h2' sx={{ mt: 3 }}>
                Upcoming Agreements
              </Typography>
              <AgreementsListConatiner
                data-testid={TestIds.feat.agreement.tabView.upcomingAgreementsList}
              >
                {upcomingAgreements?.map((e) => (
                  <SalesAgreementListItem
                    key={e.id}
                    {...e}
                    products={e.lines.map((p) => p.productDescription)}
                    percentageFulfilled={e.percentageFulfilled}
                  />
                ))}
              </AgreementsListConatiner>
            </>
          )}
        </>
      )
    }
  }, [isNoAgreement, activeAgreements, upcomingAgreements])

  return renderBody
}

export default ActiveAgreementsTabPanel
